import React from 'react';
import { Link } from 'react-router-dom';
import './ProductDetail.css';
import QuickInquiryWidget from '../../components/QuickInquiryWidget';

const WHATSAPP_MESSAGE = "Hi HOPE INTERNATIONAL, I'm interested in your export products. Please share quotation and product details.";
const WHATSAPP_LINK = `https://wa.me/916267592923?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

function MoringaPage() {
  return (
    <div className="product-detail-page">
      <QuickInquiryWidget productName="Moringa Leaf Powder" botanical="Moringa oleifera" />
      <div className="product-detail-container">
        {/* Product Header */}
        <div className="product-detail-header">
          <h1>Moringa Leaf Powder</h1>
          <p className="botanical-name">Moringa oleifera</p>
          <div className="title-underline"></div>
        </div>

        {/* Top Action Buttons */}
        <div className="top-action-buttons">
          <Link to="/request-quote" className="btn-action-primary">Request a Quote</Link>
          <Link to="/request-sample" className="btn-action-secondary">Request a Sample</Link>
          <Link to="/request-coa" className="btn-action-tertiary">Request COA / Specs</Link>
        </div>

        {/* Product Overview */}
        <section className="product-section">
          <h2>Product Overview</h2>
          <p>Moringa Leaf Powder is a nutrient-rich green superfood ingredient commonly used in health supplements, smoothies, and functional food products. HOPE INTERNATIONAL supplies export-quality Moringa powder processed for consistent texture and buyer-ready documentation.</p>
        </section>

        {/* Key Features */}
        <section className="product-section">
          <h2>Key Features</h2>
          <ul className="feature-list">
            <li>Made from clean, dried moringa leaves</li>
            <li>Fine green powder suitable for multiple applications</li>
            <li>Consistent bulk supply available</li>
            <li>COA available on request (batch-wise)</li>
          </ul>
        </section>

        {/* Typical Applications */}
        <section className="product-section">
          <h2>Typical Applications</h2>
          <div className="applications-grid">
            <div className="application-item">Smoothies, wellness drinks & juice mixes</div>
            <div className="application-item">Capsules, tablets, and nutraceutical blends</div>
            <div className="application-item">Functional food and seasoning blends</div>
            <div className="application-item">Private label retail packing</div>
          </div>
        </section>

        {/* Available Specifications */}
        <section className="product-section specs-section">
          <h2>Available Specifications</h2>
          <p className="specs-note">On Request / As per COA</p>
          <div className="specs-table">
            <div className="spec-row">
              <span className="spec-label">Form</span>
              <span className="spec-value">Powder</span>
            </div>
            <div className="spec-row">
              <span className="spec-label">Botanical Name</span>
              <span className="spec-value">Moringa oleifera</span>
            </div>
            <div className="spec-row">
              <span className="spec-label">Part Used</span>
              <span className="spec-value">Leaf</span>
            </div>
            <div className="spec-row">
              <span className="spec-label">Mesh Size Options</span>
              <span className="spec-value">60 / 80 / 100 mesh (custom available)</span>
            </div>
            <div className="spec-row">
              <span className="spec-label">Moisture</span>
              <span className="spec-value">As per batch COA</span>
            </div>
            <div className="spec-row">
              <span className="spec-label">Shelf Life</span>
              <span className="spec-value">Typically up to 24 months (as per storage conditions)</span>
            </div>
          </div>
        </section>

        {/* Packaging Options */}
        <section className="product-section">
          <h2>Packaging Options</h2>
          <div className="packaging-options">
            <div className="package-item">
              <span className="package-type">Bulk Export Pack</span>
              <span className="package-desc">25 kg kraft paper bag</span>
            </div>
            <div className="package-item">
              <span className="package-type">Retail Pack</span>
              <span className="package-desc">100g matte pouch</span>
            </div>
            <div className="package-item">
              <span className="package-type">Retail Pack</span>
              <span className="package-desc">250g matte pouch</span>
            </div>
          </div>
          <p className="packaging-note">Custom labeling available on request</p>
        </section>

        {/* Documents Available */}
        <section className="product-section">
          <h2>Documents Available</h2>
          <ul className="document-list">
            <li>COA (Certificate of Analysis)</li>
            <li>MSDS / SDS</li>
            <li>Certificate of Origin</li>
            <li>Commercial Invoice & Packing List</li>
            <li>Export documentation support (as per destination requirement)</li>
          </ul>
        </section>

        {/* Industries We Serve */}
        <section className="product-section industries-section">
          <h2>Industries We Serve</h2>
          <div className="industries-list">
            <span>Nutraceutical Manufacturers</span>
            <span>Importers & Distributors</span>
            <span>Food & Beverage Brands</span>
            <span>Private Label Brands</span>
            <span>Ayurveda Companies</span>
          </div>
        </section>

        {/* Related Products */}
        <section className="product-section">
          <h2>Related Products</h2>
          <div className="related-products">
            <Link to="/product/ashwagandha" className="related-product-link">Ashwagandha Powder</Link>
            <Link to="/product/ginger" className="related-product-link">Ginger Powder</Link>
            <Link to="/product/turmeric" className="related-product-link">Turmeric Powder</Link>
            <Link to="/product/neem" className="related-product-link">Neem Powder</Link>
          </div>
        </section>

        {/* Final CTA */}
        <section className="product-cta-section">
          <h3>Share your required quantity and destination country to get a quick quote.</h3>
          <div className="cta-buttons">
            <Link to="/request-quote" className="btn-cta-primary">Request a Quote</Link>
            <Link to="/request-sample" className="btn-cta-secondary">Request a Sample</Link>
            <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="btn-cta-whatsapp">WhatsApp Now</a>
          </div>
        </section>
      </div>
    </div>
  );
}

export default MoringaPage;
